export enum FrequencyType {
    MONTHLY = 'MONTHLY',
    PUNCTUAL = 'PUNCTUAL',
  }
  